import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="23" viewBox="0 0 5 23">
    <path fill="#1D1D1B" fillRule="evenodd" d="M0 22.248V.448h4.354v21.8z" />
  </svg>
);
